import ViewGridGridSkeleton from './ViewGridGridSkeleton';
import ViewGridHeaderSkeleton from './ViewGridHeaderSkeleton';

/** Full View Grid page skeleton — route Suspense fallback. */
const ViewGridPageSkeleton = () => (
  <div className="a0_vh100">
    <div
      className="container-fluid ao_rowBg boxShadowOutset"
      id="fullScreenMainContainer"
    >
      <div className="ao_mainContainer py-3">
        <ViewGridHeaderSkeleton />
      </div>
    </div>
    <ViewGridGridSkeleton />
  </div>
);

export default ViewGridPageSkeleton;
